// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3V5gM","inputWrap":"CustomTip_inputWrap__1vIzK"};